const brands = [
  "Apple",
  "Microsoft",
  "Google",
  "Amazon",
  "Samsung",
  "IBM",
  "Intel",
  "Facebook",
  "Sony",
  "HP",
  "Dell",
  "Cisco",
  "Oracle",
  "Lenovo",
  "Nokia",
  "Panasonic",
  "Adobe",
  "ASUS",
  "Toshiba",
  "LG",
  "Xiaomi",
  "Qualcomm",
  "Uber",
  "Airbnb",
  "Twitter",
  "Snapchat",
  "LinkedIn",
  "Pinterest",
  "Reddit",
  "Spotify",
  "Dropbox",
  "PayPal",
  "Salesforce",
  "Slack",
  "Zoom",
  "TikTok",
  "Nvidia",
  "AMD",
  "EA",
  "Activision",
  "Ubisoft",
  "Square",
  "Etsy",
  "Alibaba",
  "Netflix",
  "Hulu",
  "Tesla",
  "Fitbit",
  "GoPro",
  "Roku",
  "Canon",
  "Vizio",
  "JBL",
  "Western Digital",
  "Seagate",
  "Kingston",
  "Logitech",
  "Corsair",
  "Razer",
  "Sonos",
  "Blackberry",
  "Fujitsu",
  "Garmin",
  "Hewlett-Packard",
  "McAfee",
  "Nintendo",
  "Norton",
  "Opera",
  "SAP",
  "Sharp",
  "Symantec",
  "VMware",
  "Yamaha",
  "Acer",
  "Alienware",
  "Bose",
  "Cannon",
  "Casio",
  "Epson",
  "Fossil",
  "Gateway",
  "Honor",
  "HTC",
  "Insignia",
  "Kodak",
  "Kyocera",
  "Mitsubishi Electric",
  "NEC",
  "Olympus",
  "Pioneer",
  "Sanyo",
  "ViewSonic",
  "Xerox",
  "ZTE",
];

export default brands;
